import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { title: "Szálláshelyek" }, {
    text: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        label: "Keresés",
        "prepend-inner-icon": "mdi-magnify",
        variant: "outlined",
        "hide-details": "",
        "single-line": ""
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.accommodations,
        search: _ctx.search
      }, {
        [`item.id`]: _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: "blue",
            text: "Részletek",
            onClick: () => _ctx.handleViewClick(item.id)
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1032, ["headers", "items", "search"])
    ]),
    _: 1
  }))
}